
import Vue, { PropType } from 'vue'
import CIcon from '../c-icon/c-icon.component.vue'
import { Icon } from '../c-icon/class/icon'
import { RibbonStyles } from './enum/ribbon-styles.enum'

export default Vue.extend({
  components: {
    CIcon
  },
  props: {
    /**
     * The text inside of this component
     */
    ribbonText: {
      type: Array as PropType<String[]>,
      required: true
    },
    /**
     * The css class for this component
     */
    classes: {
      type: String,
      required: false,
      default: RibbonStyles.default
    },
    /**
     * Override default height
     */
    height: {
      type: String,
      required: false,
      default: '70px'
    },
    /**
     * Optional Ribbon Icon. Placed on the left hand side.
     */
    icon: {
      type: Object as PropType<Icon>,
      required: false
    }
  }
})
